import React from 'react';
import styled from 'styled-components';

import useOpenModal from '../../../hooks/useOpenModal';

const AlreadyHaveAccountSection = ({ isSmallScreen }: AlreadyHaveAccountSectionProps) => {
	const handleOpenModal = useOpenModal();

	return (
		<AlreadyHaveAccountSectionContainer>
			<InlineText isSmallScreen={isSmallScreen}>
				Already have an account?{' '}
				<LinkButton type="button" onClick={() => handleOpenModal('login')}>
					<UnderlineText isSmallScreen={isSmallScreen}>Login</UnderlineText>
				</LinkButton>
			</InlineText>
		</AlreadyHaveAccountSectionContainer>
	);
};

export default AlreadyHaveAccountSection;

interface AlreadyHaveAccountSectionProps {
	isSmallScreen: boolean;
}

const AlreadyHaveAccountSectionContainer = styled.div({
	display: 'flex',
	flexDirection: 'column',
	margin: '20px 0',
	textAlign: 'center',
});

const InlineText = styled.p<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
	display: 'flex',
	flexDirection: 'row',
	color: theme.colors.darkR,
	fontSize: isSmallScreen ? '14px' : '18px',
	margin: '5px 0',
	alignItems: 'center',
	justifyContent: 'center',
}));

const UnderlineText = styled(InlineText)({
	textDecoration: 'underline',
});

const LinkButton = styled.button`
	display: inline;
	margin-left: 5px;
	margin-right: 5px;
	&:focus {
		outline: none;
	}
`;
